/* Модальное окно об отсутствии программ на странице программ */
function modalMissCategorySearchJob() {
  let a = document.querySelector(".ProgramsModalCategorySearchJob__btn"),
    modal = document.createElement("div"),
    modalRegions = document.querySelectorAll(".modal-categorySearchJob");

  /* Очищаем модальное окно */
  if (modalRegions.length > 0) {
    modalRegions.forEach((modal) => modal.remove());
  }

  /* Создаем модальное окно */
  if (!a) {
    (a = document.createElement("button")),
      a.setAttribute("data-modal-open", "");
    a.setAttribute("data-modal-id", "ProgramsModalCategorySearchJob");
    a.setAttribute("data-modal-close", "");
    a.classList.add("ProgramsModalCategorySearchJob__btn");
    a.style.display = "none";
    document.body.append(a);
  }

  modal.classList.add("custom-modal__hidden", "modal-categorySearchJob");
  modal.id = "ProgramsModalCategorySearchJob";
  modal.innerHTML = `<div class="modal-programs__content">
        <h3>Пожалуйста, выберите другую программу</h3>
        <p>Для категории «Граждане, ищущие работу (или трудоустроенные)»
        мы&nbsp;разработали определенные программы по наиболее перспективным специальностям</p>
        <p><strong>5 самых популярных курсов:</strong></p>
        <ul>
            <li><a href="/program/onec144">1С программист</a></li>
            <li><a href="/program/personneladmin">Кадровый учет: администрирование трудовых отношений</a></li>
            <li><a href="/program/accountant">Бухгалтер субъекта малого бизнеса</a></li>
            <li><a href="/program/softwaretesting">Тестировщик программного обеспечения</a></li>
        </ul>
        <p><strong>Ознакомиться с полным перечнем бесплатных программ для вашей категории вы&nbsp;можете по&nbsp;кнопке ниже</strong></p>
        <a href="/catalog" class="btn">Выбрать курс</a>
      </div>`;
  document.body.append(modal);
  a.click();
}

export default modalMissCategorySearchJob;
